import React, { useEffect, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import axios from "axios";
import { storage } from "../../utils";
import { useDashboardRole } from "../../context/dashboardRole";

async function authHeaders() {
  const token = await storage.load("token");
  return { "x-auth": token };
}

const MagArticles = () => {
  const { role, loading } = useDashboardRole();
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState("");
  const [filter, setFilter] = useState("");

  const load = async () => {
    try {
      const headers = await authHeaders();
      const qs = filter ? `?status=${filter}` : "";
      const res = await axios.get(`/mag/admin/articles${qs}`, { headers });
      setRows(res.data.data || []);
      setErr("");
    } catch (e) {
      setErr("بارگذاری مقالات ممکن نشد.");
    }
  };

  useEffect(() => {
    if (role === "owner") load();
  }, [role, filter]);

  if (!loading && role !== "owner") {
    return <Redirect to="/dashboard/access-denied" />;
  }

  return (
    <div className="content-body" style={{ padding: "1.5rem" }}>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h3 className="mb-0">پایپ‌مگ — مقالات</h3>
        <Link className="btn btn-primary" to="/dashboard/mag/new">
          مقاله جدید
        </Link>
      </div>
      <p className="text-muted">
        فقط مالک می‌تواند مجله را مدیریت کند. کارمندان سفارش به این بخش دسترسی
        ندارند.
      </p>
      <div className="mb-2">
        <select
          className="form-control"
          style={{ maxWidth: 220 }}
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        >
          <option value="">همه وضعیت‌ها</option>
          <option value="draft">پیش‌نویس</option>
          <option value="published">منتشرشده</option>
        </select>
      </div>
      {err ? <div className="alert alert-danger">{err}</div> : null}
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>عنوان</th>
              <th>دسته</th>
              <th>وضعیت</th>
              <th>نویسنده</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id}>
                <td>
                  {r.title}
                  {r.is_synthetic ? (
                    <span className="badge badge-warning mr-1">آزمایشی</span>
                  ) : null}
                </td>
                <td>{r.category_name || "—"}</td>
                <td>{r.status === "published" ? "منتشرشده" : "پیش‌نویس"}</td>
                <td>{r.author_name}</td>
                <td>
                  <Link to={`/dashboard/mag/edit/${r.id}`}>ویرایش</Link>
                </td>
              </tr>
            ))}
            {!rows.length ? (
              <tr>
                <td colSpan={5}>مقاله‌ای ثبت نشده است.</td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
      <Link to="/dashboard/mag/categories">مدیریت دسته‌بندی‌ها</Link>
    </div>
  );
};

export { MagArticles };
